import { OnInit } from '@angular/core';
var UserComponent = /** @class */ (function () {
    function UserComponent() {
    }
    UserComponent.prototype.ngOnInit = function () {
        this.userFullName = this.user.name + " " + this.user.surname;
    };
    Object.defineProperty(UserComponent.prototype, "isAgentTalkState", {
        get: function () {
            return !!this.user.agentState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserComponent.prototype, "classBasedOnUserState", {
        get: function () {
            if (this.isAgentTalkState) {
                switch (this.user.agentState) {
                    case 'IDLE':
                        return 'on';
                    case 'WAITING':
                    case 'PAUSED':
                    case 'BUSY':
                    default:
                        return 'away';
                }
            }
            else if (!this.isAgentTalkState) {
                switch (this.user.state) {
                    case 'ACTIVE':
                        return 'on';
                    case 'PENDING':
                        return 'talking';
                    case 'INACTIVE':
                    default:
                        return 'away';
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return UserComponent;
}());
export { UserComponent };
